export const API_KEY = 'AIzaSyBi6cxitVmc501sE-EvXEmGyafFrFU-z4E'
export const CLIENT_ID = '677640597900-6u8chs2kkjj50ramfapb07sb19bm1kl4.apps.googleusercontent.com'
export const CLIENT_SECRET = 'J9FlxH4HpgS-ORSlz4h2JBAb'
export const SPREADSHEET_ID = '1kaEKjWUXy7ORaIShqtTh34T4mWQt852aJOuIGngUYXY'
export const ENDPOINT = 'https://v1.nocodeapi.com/kushad/google_sheets/dwAxNxuItSlZQMnF?tabId=ENROLLMENT_DATA'
export const SPREADSHEET_URL = 'https://docs.google.com/spreadsheets/d/1kaEKjWUXy7ORaIShqtTh34T4mWQt852aJOuIGngUYXY/edit#gid=0'
export const NETLIFY_SITE_ID = {
    "siteId": '0dfecee6-3345-4829-818c-9e1cdbeab066'
}
